<template>
  <div id="campReportDiv" class="slds-var-p-around_small">
    <notifications group="error" position="top center">
      <template slot="body" slot-scope="props">
        <div class="slds-notify_container slds-is-relative">
          <div
            class="slds-notify slds-notify_toast slds-theme_error"
            role="status"
          >
            <span class="slds-assistive-text">error</span>
            <span
              class="slds-icon_container slds-icon-utility-error slds-m-right_small slds-no-flex slds-align-top"
              title="Description of icon when needed"
            >
              <svg class="slds-icon slds-icon_small" aria-hidden="true">
                <use
                  xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"
                ></use>
              </svg>
            </span>
            <div class="slds-notify__content">
              <h2
                class="slds-text-heading_small"
                v-html="props.item.title"
              ></h2>
              <p v-html="props.item.text"></p>
            </div>
            <div class="slds-notify__close">
              <button
                class="slds-button slds-button_icon slds-button_icon-inverse"
                title="Close"
                @click="props.close"
              >
                <svg
                  class="slds-button__icon slds-button__icon_large"
                  aria-hidden="true"
                >
                  <use
                    xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"
                  ></use>
                </svg>
                <span class="slds-assistive-text">Close</span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </notifications>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="fullPage"
      ></loading>
    </div>
    <div class="slds-page-header slds-page-header_record-home">
      <div class="slds-page-header__row">
        <div class="slds-page-header__col-title">
          <div class="slds-media">
            <div class="slds-media__figure">
              <span class="slds-icon_container slds-icon-standard-opportunity">
                <svg
                  class="slds-icon slds-page-header__icon"
                  aria-hidden="true"
                >
                  <use
                    xlink:href="/assets/icons/custom-sprite/svg/symbols.svg#custom102"
                  ></use>
                </svg>
              </span>
            </div>
            <div class="slds-media__body">
              <div class="slds-page-header__name">
                <div class="slds-page-header__name-title">
                  <h1>
                    <span></span>
                    <span
                      class="slds-page-header__title slds-truncate"
                      title="Analysis"
                      >Analysis Report</span
                    >
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slds-page-header__col-actions">
          <div class="slds-page-header__controls">
            <div class="slds-page-header__control">
              <ul class="slds-button-group-row">
                <template v-if="progress < 100">
                  <li class="slds-button-group-item">
                    <progress-ring
                      :radius="15"
                      :progress="progress"
                      :stroke="4"
                    ></progress-ring>
                  </li>
                </template>
                <li class="slds-button-group-item slds-is-relative">
                  <button
                    class="slds-button slds-button_icon slds-button_icon-brand"
                    title="Show/Hide Columns"
                    @click="showHideColumns = !showHideColumns"
                  >
                    <svg class="slds-button__icon" aria-hidden="true">
                      <use
                        xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#hide"
                      ></use>
                    </svg>
                    <span class="slds-assistive-text">Show/Hide Columns</span>
                  </button>
                  <section
                    v-if="!showHideColumns"
                    aria-describedby="dialog-body-id-98"
                    aria-labelledby="dialog-heading-id-103"
                    class="slds-popover slds-nubbin_right-top slds-is-absolute showHidePosition"
                    role="dialog"
                  >
                    <header class="slds-popover__header">
                      <h2
                        class="slds-text-heading_small"
                        id="dialog-heading-id-103"
                      >
                        Show/Hide Columns
                      </h2>
                    </header>
                    <div
                      class="slds-popover__body slds-popover__body_small"
                      id="dialog-body-id-98"
                    >
                      <div class="slds-text-longform">
                        <div
                          class="slds-form-element slds-m-bottom_x-small"
                          v-for="header in currentHeaders"
                          :key="header.value"
                        >
                          <label class="slds-checkbox_toggle slds-grid">
                            <span
                              class="slds-form-element__label slds-m-bottom_none"
                              >{{ header.text }}</span
                            >
                            <input
                              type="checkbox"
                              name="checkbox-toggle-58"
                              value="checkbox-toggle-58"
                              aria-describedby="checkbox-toggle-58"
                              v-model="header.selected"
                            />
                            <span
                              id="checkbox-toggle-58"
                              class="slds-checkbox_faux_container slds-col_bump-left"
                              aria-live="assertive"
                            >
                              <span class="slds-checkbox_faux"></span>
                              <span class="slds-checkbox_on"></span>
                              <span class="slds-checkbox_off"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </section>
                </li>
                <li class="slds-button-group-item">
                  <router-link
                    :to="{
                      name: 'CampaignAnalysis',
                      params: {
                        filter: this.backData,
                        campIds: this.strCampIds,
                        selectedOptions: this.selectedOptions,
                      },
                    }"
                  >
                    <button
                      class="slds-button slds-button_icon slds-button_icon-brand"
                      title="Filter"
                      v-on:click="backToCamp()"
                    >
                      <svg class="slds-button__icon" aria-hidden="true">
                        <use
                          xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#filterList"
                        ></use>
                      </svg>
                      <span class="slds-assistive-text">Filter</span>
                    </button>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="slds-page-header__row slds-page-header__row_gutters">
        <div class="slds-page-header__col-details">
          <nav role="navigation" aria-label="Breadcrumbs">
            <ol
              class="slds-breadcrumb slds-list_horizontal slds-wrap slds-page-header__detail-row"
            >
              <template v-if="IsFromSegments">
                <li class="slds-breadcrumb__item">
                  <router-link
                    :to="{
                      name: 'Segments',
                      params: { dashboardData: this.dashboardInfo },
                    }"
                  >
                    <a href="javascript:void(0);">{{
                      this.dashboardInfo.name
                    }}</a>
                  </router-link>
                </li>
                <li class="slds-breadcrumb__item">
                  <router-link
                    :to="{
                      name: 'Segments',
                      params: { dashboardData: this.dashboardInfo },
                    }"
                  >
                    <a href="javascript:void(0);">{{
                      this.campIds.segmentName
                    }}</a>
                  </router-link>
                </li>
              </template>
              <template v-if="!IsFromSegments && this.groupingValues.length">
                <li class="slds-breadcrumb__item">
                  <a
                    href="javascript:void(0);"
                    @click="backtoSubtotalFromAnalysis(false)"
                    >{{ getSubtotalColumnType("startDate") }}</a
                  >
                </li>
                <li
                  class="slds-breadcrumb__item"
                  v-if="
                    this.selectedSubtotalName != null &&
                      this.selectedSubtotalName != ''
                  "
                >
                  <a
                    href="javascript:void(0);"
                    @click="backtoSubtotalFromAnalysis(false)"
                    >{{ this.selectedSubtotalName }}</a
                  >
                </li>
              </template>
              <li
                class="slds-breadcrumb__item"
                v-if="
                  this.selectedCampaignId != null &&
                    this.selectedCampaignId != ''
                "
              >
                <a
                  href="javascript:void(0);"
                  @click="backtoSubtotalFromAnalysis(true)"
                  >{{ this.selectedCampaignId }}</a
                >
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <!--Filter Pills-->
      <br />
      <span
        v-for="data in backData"
        :key="data.value"
        class="slds-pill slds-pill_link"
      >
        <a
          href="#"
          class="slds-pill"
          title="Full pill label verbiage mirrored here"
        >
          <span class="slds-pill__label">
            <!-- USE LDS CSS for class bold-->
            <p style="font-weight: bold;">{{ data.filterTypeLabel }}:</p>
            <p>{{ data.filterTypeText }}</p>
          </span>
        </a>
      </span>
    </div>
    <div ref="root">
      <template v-if="isRendered">
        <table
          ref="viewport"
          v-if="campaignExists"
          class="slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-table_striped slds-no-row-hover v-cloak--table"
        >
          <colgroup>
            <col
              v-for="header in filteredCampaignHeaders"
              :key="header.value"
              :class="header.cssClass"
            />
          </colgroup>
          <thead>
            <tr class="slds-line-height_reset">
              <table-head-row
                v-for="header in filteredCampaignHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
            <tr class="slds-line-height_reset">
              <table-head-cell-filter
                v-for="header in filteredCampaignHeaders"
                :key="header.value"
                :colName="header.text"
                :colKey="header.value"
                :colType="header.type"
                :filterable="header.filterable"
              ></table-head-cell-filter>
            </tr>
          </thead>
          <tbody ref="spacer" :style="spacerStyle">
            <template v-if="sortedCampaignData.length">
              <tr v-for="data in sortedCampaignData" :key="data.CampaignID">
                <td
                  v-for="header in filteredCampaignHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.onClick">
                    <a
                      @click="
                        callFunction(header.onClick, [data.id], data.campaignId)
                      "
                    >
                      {{
                        dataFormatter(data[header.value], header.dataFormatter)
                      }}
                      <template v-if="data.totalCost == 0">
                        <span
                          class="slds-icon_container slds-icon-utility-record"
                          title="Description of icon when needed"
                        >
                          <svg
                            class="slds-icon slds-icon-text-error slds-icon_small"
                            aria-hidden="true"
                          >
                            <use
                              xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#record"
                            ></use>
                          </svg>
                        </span>
                      </template>
                    </a>
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(data[header.value], header.dataFormatter)
                    }}
                  </template>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8">
                  <no-results message="No campaign data found" />
                </td>
              </tr>
            </template>
            <template v-if="sortedCampaignData.length">
              <tr>
                <td
                  v-for="header in filteredCampaignHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.onClick">
                    <a
                      @click="
                        callFunction(
                          header.onClick,
                          summaryRow.campaignId,
                          'Multiple Campaigns'
                        )
                      "
                    >
                      Total
                    </a>
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(
                        summaryRow[header.value],
                        header.dataFormatter
                      )
                    }}
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr>
              <table-head-row
                v-for="header in filteredCampaignHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
          </tfoot>
        </table>

        <!--Subtotal Table View-->
        <table
          v-if="subTotalExist"
          class="slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-table_striped slds-no-row-hover v-cloak--table"
        >
          <colgroup>
            <col
              v-for="header in filteredSubtotalHeaders"
              :key="header.value"
              :class="header.cssClass"
            />
          </colgroup>
          <thead>
            <tr class="slds-line-height_reset">
              <table-head-row
                v-for="header in filteredSubtotalHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
            <tr class="slds-line-height_reset">
              <table-head-cell-filter
                v-for="header in filteredSubtotalHeaders"
                :key="header.value"
                :colName="header.text"
                :colKey="header.value"
                :colType="header.type"
                :filterable="header.filterable"
              ></table-head-cell-filter>
            </tr>
          </thead>
          <tbody>
            <template v-if="sortedSubtotalData.length">
              <tr v-for="data in sortedSubtotalData" :key="data.CampaignID">
                <td
                  v-for="(header, index) in filteredSubtotalHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.onClick">
                    <a @click="callFunction(header.onClick, data)">
                      {{
                        dataFormatter(data[header.value], header.dataFormatter)
                      }}
                      <template v-if="data.totalCost == 0 && index == 1">
                        <span
                          class="slds-icon_container slds-icon-utility-record"
                          title="Description of icon when needed"
                        >
                          <svg
                            class="slds-icon slds-icon-text-error slds-icon_small"
                            aria-hidden="true"
                          >
                            <use
                              xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#record"
                            ></use>
                          </svg>
                        </span>
                      </template>
                    </a>
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(data[header.value], header.dataFormatter)
                    }}
                  </template>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8">
                  <no-results message="No grouping data found" />
                </td>
              </tr>
            </template>
            <template v-if="sortedSubtotalData.length">
              <tr>
                <td
                  v-for="header in filteredSubtotalHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.onClick">
                    Total
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(
                        summaryRow[header.value],
                        header.dataFormatter
                      )
                    }}
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr>
              <table-head-row
                v-for="header in filteredSubtotalHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
          </tfoot>
        </table>

        <table
          v-if="campaignGiftDataExists"
          class="slds-m-top_large slds-table slds-table_fixed-layout slds-table_bordered slds-table_striped slds-no-row-hover v-cloak--table"
        >
          <colgroup>
            <col
              v-for="header in filteredGiftHeaders"
              :key="header.value"
              :class="header.cssClass"
            />
          </colgroup>
          <thead>
            <tr class="slds-line-height_reset">
              <table-head-row
                v-for="header in filteredGiftHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
            <tr class="slds-line-height_reset">
              <table-head-cell-filter
                v-for="header in filteredGiftHeaders"
                :key="header.value"
                :colName="header.text"
                :colKey="header.value"
                :colType="header.type"
                :filterable="header.filterable"
              ></table-head-cell-filter>
            </tr>
          </thead>
          <tbody>
            <template v-if="sortedGiftData.length">
              <tr v-for="data in sortedGiftData" :key="data.CampaignID">
                <td
                  v-for="header in filteredGiftHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.value == 'constituentId'">
                    <a
                      :href="
                        'https://leadershipinstitute.lightning.force.com/lightning/r/Account/' +
                          data.accountId +
                          '/view'
                      "
                      target="_blank"
                    >
                      {{
                        dataFormatter(data[header.value], header.dataFormatter)
                      }}
                    </a>
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(data[header.value], header.dataFormatter)
                    }}
                  </template>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8">
                  <no-results message="No gift data found" />
                </td>
              </tr>
            </template>
            <template v-if="sortedGiftData.length">
              <tr>
                <td
                  v-for="header in filteredGiftHeaders"
                  :key="header.value"
                  :class="header.dataCssClass"
                  :scope="header.dataScope"
                >
                  <template v-if="header.value == 'constituentId'">
                    Total
                  </template>
                  <template v-else>
                    {{
                      dataFormatter(
                        summaryRow[header.value],
                        header.dataFormatter
                      )
                    }}
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr>
              <table-head-row
                v-for="header in filteredGiftHeaders"
                :key="header.value"
                :text="header.text"
                :columnKey="header.value"
                :columnType="header.type"
                :sortable="header.sortable"
              ></table-head-row>
            </tr>
          </tfoot>
        </table>
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
import {
  getCampaignDataUrl,
  getCampaignDataWithFilterUrl,
  getCampaignReportUrl,
  getCampaignGiftDetailsUrl,
} from "../config";
import ApiService from "../service/apiService";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import operatorFn from "../mixins/operators";
import passiveSupport from "../mixins/passiveSupport";

//Vue.use(Loading);
const SUBTOTAL_TABLE_TYPE = "Subtotal";
const GIFT_TABLE_TYPE = "Gifts";
const CAMPAIGN_TABLE_TYPE = "Campaigns";
//const FIRST_LOAD_DATA_COUNT = 99;
const LAZY_LOAD_DATA_COUNT = 250;
//const LAZY_LOAD_DELAY = 1*100; //milliseconds

const GROUPING_LABEL_VALUE = new Map([
  [
    "c.Channel__c",
    { valueKey: "channel", label: "Channel", typeCode: "CHANNEL", value: "" },
  ],
  [
    "c.Detail_Channel__c",
    {
      valueKey: "detailChannel",
      label: "Detail Channel",
      typeCode: "DETAIL_CHANNEL",
      value: "",
    },
  ],
  [
    "c.Signer__c",
    { valueKey: "signer", label: "Signer", typeCode: "SIGNER", value: "" },
  ],
  [
    "c.StartDate",
    {
      valueKey: "startDate",
      label: "Start Date",
      typeCode: "SPECIFICAPPEALSTARTDATE",
      value: "",
    },
  ],
  [
    "c.Mailing_List__c",
    { valueKey: "listName", label: "List", typeCode: "MAILINGLIST", value: "" },
  ],
  [
    "c.List_Select__c",
    {
      valueKey: "selectList",
      label: "Select",
      typeCode: "LISTSELECT",
      value: "",
    },
  ],
  [
    "c.Category__c",
    { valueKey: "purpose", label: "Purpose", typeCode: "PURPOSE", value: "" },
  ],
  [
    "c.master_Campaign__c",
    {
      valueKey: "masterCampaign",
      label: "Master Campaign",
      typeCode: "MASTERCAMPAIGN",
      value: "",
    },
  ],
]);

export default {
  name: "CampaignReport",
  mixins: [operatorFn, passiveSupport],
  props: {
    filterData: {
      type: Array,
    },
  },
  data() {
    return {
      camData: [],
      giftData: [],
      backData: [],
      currentFilter: [],
      currentSort: "",
      currentSortDir: "asc",
      currentSortDataType: "",
      isLoading: false,
      fullPage: true,
      isRendered: false,
      isUpgradeAnalysis: false,
      isEmailAnalysis: false,
      isSubsequentAnalysis: false,
      isPercentColumns: false,
      excludeInTotals: false,
      subTotalExist: false,
      campIds: "",
      strCampIds: "",
      campaignExists: false,
      camDataSubtotal: [],
      filterFromSubtotal: [],
      groupingValues: [],
      groupingFilterValues: [],
      IsFromSegments: false,
      campaignGiftDataExists: false,
      dashboardInfo: {},
      selectedSubtotalName: "",
      selectedCampaignId: "",
      selectedOptions: {},
      showHideColumns: true,
      summaryData: {},
      lazyLoadData: [],
      freshData: false,
      progress: 0,
      rootHeight: 2000, // Total height of the root which contains all the list items in px
      rowHeight: 30, // Height of each row, give it an initial value but this gets calculated dynamically on mounted
      scrollTop: 0, // Current scroll top position, we update this inside the scroll event handler
      // Extra padding at the top and bottom so that the items transition smoothly
      // Think of it as extra items just before the viewport starts and just after the viewport ends
      nodePadding: 20,
    };
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    TableHeadRow: () => import("./TableHeadRow.vue"),
    TableHeadCellFilter: () => import("./TableHeadCellFilter.vue"),
    ProgressRing: () => import("./ProgressRing.vue"),
    NoResults: () => import("./NoResults.vue"),
  },
  computed: {
    /**
			Total height of the viewport = number of items in the array x height of each item
			*/
    viewportHeight() {
      return this.itemCount * this.rowHeight;
    },
    /**
			Out of all the items in the massive array, we only render a subset of them
			This is the starting index from which we show a few items
			*/
    startIndex() {
      let startNode =
        Math.floor(this.scrollTop / this.rowHeight) - this.nodePadding;
      startNode = Math.max(0, startNode);
      return startNode;
    },
    /**
			This is the number of items we show after the starting index
			If the array has a total 10000 items, we want to show items from say index 1049 till 1069
			visible node count is that number 20 and starting index is 1049
			*/
    visibleNodeCount() {
      let count =
        Math.ceil(this.rootHeight / this.rowHeight) + 2 * this.nodePadding;
      count = Math.min(this.itemCount - this.startIndex, count);
      return count;
    },
    /**
			Subset of items shown from the full array
			*/
    visibleItems(reportData) {
      return reportData.slice(
        this.startIndex,
        this.startIndex + this.visibleNodeCount
      );
    },
    itemCount() {
      return this.camData.length;
    },
    /**
			The amount by which we need to translateY the items shown on the screen so that the scrollbar shows up correctly
			*/
    offsetY() {
      return this.startIndex * this.rowHeight;
    },
    /**
			This is the direct list container, we apply a translateY to this
			*/
    spacerStyle() {
      return {
        transform: "translateY(" + this.offsetY + "px)",
      };
    },
    viewportStyle() {
      return {
        overflow: "hidden",
        height: this.viewportHeight + "px",
        position: "relative",
      };
    },
    rootStyle() {
      return {
        height: this.rootHeight + "px",
        overflow: "auto",
      };
    },
    currentHeaders() {
      if (this.campaignExists) {
        return this.campaignAnalysisHeaders;
      }

      if (this.subTotalExist) {
        return this.subtotalAnalysisHeaders;
      }

      if (this.campaignGiftDataExists) {
        return this.giftAnalysisHeaders;
      }

      return {};
    },
    sortedCampaignData() {
      return this.sortData(this.camData, "camData");
    },
    sortedSubtotalData() {
      return this.sortData(this.camDataSubtotal, "camDataSubtotal");
    },
    sortedGiftData() {
      return this.sortData(this.giftData, "giftData");
    },
    giftAnalysisHeaders() {
      let tableHeaders = this.$store.state.firstColumnHeader.concat(
        this.$store.state.giftHeaders
      );

      if (this.isUpgradeAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.giftUpgradeAnalysisHeaders
        );
      }

      if (this.isEmailAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.giftEmailAnalysisHeaders
        );
      }

      if (this.isSubsequentAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.giftSubsequentGivingHeaders
        );
      }
      return tableHeaders;
    },
    filteredGiftHeaders() {
      return this.giftAnalysisHeaders.filter((h) => h.selected);
    },
    subtotalAnalysisHeaders() {
      let tableHeaders = this.$store.state.firstColumnHeader.concat(
        this.$store.state.subtotalHeaders
      );

      if (this.isUpgradeAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campUpgradeAnalysisHeaders
        );
      }

      if (this.isEmailAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campEmailAnalysisHeaders
        );
      }

      if (this.isSubsequentAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campSubsequentAnalysisHeaders
        );
      }

      if (this.isPercentColumns) {
        this.addPercentColumns(tableHeaders);
      }
      return tableHeaders;
    },
    filteredSubtotalHeaders() {
      let columnValues = this.groupingValues.map((el) => el.valueKey);

      this.subtotalAnalysisHeaders.forEach((el) => {
        if (
          [
            "listName",
            "selectList",
            "signer",
            "startDate",
            "channel",
            "detailChannel",
          ].includes(el.value)
        ) {
          el.selected = columnValues.includes(el.value) ? true : false;
        }
      });
      return this.subtotalAnalysisHeaders.filter((h) => h.selected);
    },
    campaignAnalysisHeaders() {
      let tableHeaders = this.$store.state.firstColumnHeader.concat(
        this.$store.state.campaignHeaders
      );

      if (this.isUpgradeAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campUpgradeAnalysisHeaders
        );
      }

      if (this.isEmailAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campEmailAnalysisHeaders
        );
      }

      if (this.isSubsequentAnalysis) {
        tableHeaders = tableHeaders.concat(
          this.$store.state.campSubsequentAnalysisHeaders
        );
      }

      if (this.isPercentColumns) {
        this.addPercentColumns(tableHeaders);
      }
      return tableHeaders;
    },
    filteredCampaignHeaders() {
      return this.campaignAnalysisHeaders.filter((h) => h.selected);
    },
  },
  created: async function() {
    let routeParams = this.$route.params;
    //console.log('filters'+JSON.stringify(routeParams.filter));
    this.backData = routeParams.filter;

    this.isLoading = true;
    if (!routeParams.IsFromSegments) {
      if (routeParams.campIdsArr != undefined) {
        this.campIds = routeParams.campIdsArr;
      }

      this.getCampaignFilterData();
    }
    if (routeParams.IsFromSegments) {
      if (
        routeParams.dashboardData != undefined &&
        routeParams.dashboardData != null
      ) {
        this.IsFromSegments = routeParams.IsFromSegments;
        const campIds = routeParams.dashboardData;

        this.campIds = campIds;
        this.IsFromSegments = routeParams.IsFromSegments;
        this.dashboardInfo = routeParams.dashboardInfo;
        this.getCampaignDataFromCampaignIds();
      }
    }

    if (routeParams.selectedOptions != undefined) {
      this.selectedOptions = routeParams.selectedOptions;
      this.isUpgradeAnalysis = this.selectedOptions.isUpgradeAnalysis;
      this.subTotalExist = this.selectedOptions.subtotalBy.length > 0;
      this.groupingFilterValues = this.selectedOptions.subtotalBy.map(
        (el) => el.lookUpValueCode
      );
      this.isEmailAnalysis = this.selectedOptions.isEmailAnalysis;
      this.isSubsequentAnalysis = this.selectedOptions.isSubsequentAnalysis;
      this.isPercentColumns = this.selectedOptions.isPercentColumns;
      this.excludeInTotals = this.selectedOptions.excludeInTotals;
    }

    //window.addEventListener("scroll",this.handleScroll,this.doesBrowserSupportPassiveScroll() ? { passive: true } : false);
  },
  mounted() {
    /*this.$root.$on("filterDataParent", (selectedFilter) => {
				this.getCampaignFilterData(selectedFilter);
			});*/
  },
  /*destroyed() {
			window.removeEventListener("scroll", this.handleScroll);
		},*/
  methods: {
    handleScroll() {
      this.scrollTop = document.documentElement.scrollTop;
    },
    /**
			Find the largest height amongst all the children
			Remember each row has to be of the same height
			I am working on the different height version
			*/
    calculateInitialRowHeight() {
      const children = this.$refs.spacer.children;
      let largestHeight = 0;
      for (let i = 0; i < children.length; i++) {
        if (children[i].offsetHeight > largestHeight) {
          largestHeight = children[i].offsetHeight;
        }
      }
      return largestHeight;
    },
    filterTableCol: function(col, type, operator, value) {
      let filterObj = {
        column: col,
        colValue: value,
        colType: type,
        colOperator: operator,
      };
      const elementIndex = this.currentFilter.findIndex(
        (el) => el.column == col
      );

      if (elementIndex > -1) {
        let newFilterArr;
        if (value === "") {
          newFilterArr = this.currentFilter.filter((el) => el.column != col);
        } else {
          newFilterArr = [...this.currentFilter];
          newFilterArr[elementIndex] = filterObj;
        }
        this.currentFilter = [...newFilterArr];
      } else {
        this.currentFilter.push(filterObj);
      }
    },
    sortTableCol: function(col, type) {
      this.currentSortDataType = type;
      if (this.currentSort == col) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        this.currentSort = col;
      }
    },
    resetSort: function() {
      this.currentSort = "";
      this.currentSortDir = "asc";
      this.currentSortDataType = "";
      this.currentFilter = [];
    },
    // eslint-disable-next-line no-unused-vars
    sortData: function(tableData, dataName) {
      let filteredData = tableData;

      if (tableData.length) {
        this.isLoading = true;

        if (this.currentFilter.length > 0) {
          var math_it_up = {
            ">": function(x, y) {
              return x > y;
            },
            "<": function(x, y) {
              return x < y;
            },
            ">=": function(x, y) {
              return x >= y;
            },
            "<=": function(x, y) {
              return x <= y;
            },
            "=>": function(x, y) {
              return x >= y;
            },
            "=<": function(x, y) {
              return x <= y;
            },
            "=": function(x, y) {
              return x == y;
            },
            "": function(x, y) {
              return x == y;
            },
          };

          //let filters =
          filteredData = tableData.filter((row) => {
            return this.currentFilter.length > 0
              ? this.currentFilter.every((filterEl) => {
                  // Check for nulls before applying toLowerCase()
                  var content = (row[filterEl.column]
                    ? row[filterEl.column]
                    : ""
                  ).toLowerCase();

                  if (filterEl.colType == "number") {
                    var number = parseFloat(content.replace(/[^0-9.]+/g, ""));

                    return math_it_up[filterEl.colOperator](
                      number,
                      filterEl.colValue
                    );
                  } else if (filterEl.colType == "date") {
                    var dateStr = Date.parse(content);

                    return math_it_up[filterEl.colOperator](
                      dateStr,
                      filterEl.colValue
                    );
                  } else if (filterEl.colType == "") {
                    return content.includes(filterEl.colValue.toLowerCase());
                  }
                })
              : true;
          });
        }
        if (this.currentSort) {
          const getDataValue = (rowData, sortCol) => {
            let content = rowData[sortCol];

            content = content == null ? "" : content;

            switch (this.currentSortDataType) {
              case "number":
                content = content.replace(/[^\-?0-9.]/g, "");
                break;
              case "date":
                content = Date.parse(content);
                break;
            }
            return content;
          };

          const comparer = (sortCol, asc) => (a, b) =>
            ((v1, v2) =>
              v1 !== "" && v2 !== "" && !isNaN(v1) && !isNaN(v2)
                ? v1 - v2
                : v1.toString().localeCompare(v2))(
              getDataValue(asc ? a : b, sortCol),
              getDataValue(asc ? b : a, sortCol)
            );

          filteredData.sort(
            comparer(this.currentSort, this.currentSortDir == "asc")
          );
        }
        this.isLoading = false;

        /**
         * Remove rows where total cost = 0. This is valid for Grouping (Subtotal) and Campaign Analysis
         * For Campaign Gift Data, do not filter rows
         * Also, include all data in totals when excludeInTotals in TRUE
         */
        let dataForSummaryRow = this.excludeInTotals
          ? filteredData.filter((row) =>
              row.totalCost ? row.totalCost != 0 : true
            )
          : filteredData;
        let lenForAvg = dataForSummaryRow.length - 1;

        const calculateSummaryRow = (acc, currEl, currIndx) => {
          let row = {};
          this.currentHeaders
            // We only want to process columns necessary for Total row
            .filter(
              (header) => header.summaryOperation || header.summaryCalculation
            )
            // Sort such that summaryOperation columns are calculated first
            /* eslint-disable no-unused-vars */
            .sort((a, b) => (a.summaryCalculation ? 1 : -1))
            /* eslint-enable no-unused-vars */
            .forEach((el) => {
              // This is to only combine Campaign IDs
              if (el.summaryOperation == "arrayPush") {
                row[el.value] = this[el.summaryOperation](
                  Array.isArray(acc[el.value]) ? acc[el.value] : acc.id,
                  currEl.id
                );
              } else if (el.summaryOperation) {
                row[el.value] = this[el.summaryOperation](
                  acc[el.value],
                  currEl[el.value],
                  el.summaryValues || 0
                );
              } else if (el.summaryCalculation) {
                row[el.value] = eval(el.summaryCalculation);
              }

              // Setting all NaN to 0
              if (!isFinite(row[el.value]) && !el.skipFiniteCheck) {
                row[el.value] = 0;
              }

              if (
                currIndx == lenForAvg &&
                el.summaryOperation &&
                el.summaryCalculation
              ) {
                row[el.value] = row[el.value] / (lenForAvg + 1);
              }
            });

          acc = row;
          return acc;
        };

        // Add a summary row only when there is some data to be rendered
        if (filteredData.length) {
          this.summaryRow =
            dataForSummaryRow.length > 0
              ? dataForSummaryRow.reduce(calculateSummaryRow, {})
              : {};
          //this.summaryRow.campaignId = this.summaryRow.subTotalValue = this.summaryRow.constituentId = ("Total");

          //filteredData.push(summaryRow);
        }
      }

      /*// Either fresh data has been fetched or the system is lazy loading large data
				// continue loading data until finished
				if(this.freshData || this.lazyLoadData.length) {
					this.freshData = false;
					if(!this.lazyLoadData.length) {
						// We are slicing such that we always load the Total row in the first load
						this.lazyLoadData = filteredData.splice(FIRST_LOAD_DATA_COUNT, filteredData.length - 2 - FIRST_LOAD_DATA_COUNT);
					}

					this.progress = ((this[dataName].length/(this[dataName].length + this.lazyLoadData.length)) * 100);

					// Call the function, binding `this` and passing the variable name
					setTimeout(this.lazyLoadDataFn.bind(this, dataName), LAZY_LOAD_DELAY);
				}*/

      return filteredData;
      /*.slice(
					this.startIndex,
					this.startIndex + this.visibleNodeCount
				);*/
    },
    lazyLoadDataFn: async function(dataName) {
      let lastRow = this[dataName].pop();
      this[dataName] = this[dataName].concat(
        this.lazyLoadData.splice(0, LAZY_LOAD_DATA_COUNT)
      );
      this[dataName].push(lastRow);

      this.progress =
        (this[dataName].length /
          (this[dataName].length + this.lazyLoadData.length)) *
        100;
    },
    addPercentColumns: function(tableHeaders) {
      this.$store.state.campPercentColumnHeaders.forEach((percentEl) => {
        tableHeaders.splice(
          tableHeaders.findIndex(
            (el) => el.value === percentEl.calculatedColumnOf
          ) + 1,
          0,
          percentEl
        );
      });

      return tableHeaders;
    },
    getCellValue: function(cellValue) {
      return cellValue && cellValue != "null" ? cellValue : "BLANK";
    },
    getSubtotalValueName: function(groupingColumns) {
      return groupingColumns
        .map((col) => col.split(","))
        .flat()
        .map((col) => GROUPING_LABEL_VALUE.get(col.trim()));
    },
    getSubtotalColumnType: function(groupingColumns) {
      let columnHeadMap = new Map([
        ["c.Channel__c", "Channel"],
        ["c.Detail_Channel__c", "Detail Channel"],
        ["c.Signer__c", "Signer"],
        ["c.StartDate", "Start Date"],
        ["c.Mailing_List__c", "List Name"],
        ["c.List_Select__c", "Select"],
        ["c.Mailing_List__c, c.List_Select__c", "List / Select"],
      ]);

      return columnHeadMap.get(groupingColumns);
    },
    getCampaignData: async function() {
      this.axios
        .get(getCampaignDataUrl)
        .then((response) => {
          this.camData = response.data;
          this.setTableView(CAMPAIGN_TABLE_TYPE);
        })
        .catch((error) => {
          this.showError(error);
        });
    },
    getCampaignFilterData: async function() {
      let routeParams = this.$route.params;

      ApiService.getData(
        getCampaignDataWithFilterUrl,
        routeParams.filter,
        false
      )
        .then((response) => {
          if (!this.subTotalExist) {
            this.camData = response.data;
            this.setTableView(CAMPAIGN_TABLE_TYPE);
          } else if (this.subTotalExist) {
            let colVal = (this.groupingValues = this.getSubtotalValueName(
              this.groupingFilterValues
            ));
            this.$store.commit({
              type: "updateSubtotalHeaderSelected",
              colVal: colVal,
            });
            this.camDataSubtotal = response.data;
            this.setTableView(SUBTOTAL_TABLE_TYPE);
          }
        })
        .catch((error) => {
          this.showError(error);
        });
    },
    getCampaignDataFromCampaignIds: async function() {
      //this.$route.query.campIds.filterIds
      var finalIds = this.campIds.filterIds.replace(/,\s*$/, "");
      this.strCampIds = finalIds.split(",");
      if (!this.backData) {
        this.backData = [];
      }
      this.backData.push({
        filterTypeCode: "CAMPAIGNIDS",
        filterTypeArray: this.strCampIds,
        filterTypeLabel: "Campaign Names",
      });

      this.axios
        .post(getCampaignReportUrl, this.strCampIds)
        .then((response) => {
          this.camData = response.data;
          // eslint-disable-next-line no-console

          this.setTableView(CAMPAIGN_TABLE_TYPE);
        })
        .catch((error) => {
          this.showError(error);
        });
    },
    getCampaignGiftData: function(campaignId, name) {
      this.axios
        .post(getCampaignGiftDetailsUrl, [
          ...this.$route.params.filter,
          {
            filterTypeCode: "GIFT_CAMPAIGN_ID",
            filterTypeArray: campaignId,
          },
        ])
        .then((response) => {
          this.selectedCampaignId = name;
          this.giftData = response.data;
          // eslint-disable-next-line no-console
          this.setTableView(GIFT_TABLE_TYPE);
        })
        .catch((error) => {
          this.showError(error);
        });
    },
    backToCamp() {
      this.$emit("filterData", this.backData);
    },
    onCancel() {
      //console.log('User cancelled the loader.')
    },
    redirectToTable: function(values) {
      this.resetSort();
      this.isLoading = true;
      this.filterFromSubtotal = [];

      let selectedValues = this.groupingValues.map((el) => {
        el.value = values[0][el.valueKey];
        return el;
      });

      this.selectedSubtotalName = selectedValues
        .map((el) => el.value)
        .join(" / ");

      this.getCampaignFilterDatafromSubtotal(selectedValues);
    },

    /**
     * Utility function that is used to make calls to other Functions
     * based on  supplied configuration. This is usually stored in the
     * vuex store
     *
     * @param {String}  fnName    Name of the function to call
     * @param {Array}   args      Zero of more args for the function
     *
     */
    callFunction: function(fnName, ...args) {
      return this[fnName](args);
    },

    /**
     * Function that fetches the selected campaign(s) Gifts
     *
     * @param {Array}   campaignId  List of Campaign IDs
     * @param {String}  name        Name of the Campaign
     *
     */
    showGifts: function([campaignId, name]) {
      this.resetSort();
      this.isLoading = true;
      this.getCampaignGiftData(campaignId, name);
    },
    backToSubtotalView: function() {
      this.selectedSubtotalName = "";
      this.setTableView(SUBTOTAL_TABLE_TYPE);
    },
    backtoSubtotalFromAnalysis(isSubtotal) {
      //this.selectedSubtotalName = null;
      this.selectedCampaignId = null;
      if (isSubtotal) {
        //this.camData =  this.campDataFromSubtotal;
        this.setTableView(CAMPAIGN_TABLE_TYPE);
      } else {
        this.selectedSubtotalName = null;
        this.setTableView(SUBTOTAL_TABLE_TYPE);
      }
    },
    getCampaignFilterDatafromSubtotal: function(values) {
      this.filterFromSubtotal = this.$route.params.filter.filter(
        (value) => value.filterTypeCode != "SUBTOTAL_BY"
      );

      values.forEach((val) => {
        this.filterFromSubtotal.push({
          filterTypeCode: val.typeCode,
          filterTypeText: val.value,
        });
      });

      ApiService.getData(
        getCampaignDataWithFilterUrl,
        this.filterFromSubtotal,
        false
      )
        .then((response) => {
          this.camData = response.data;
          this.setTableView(CAMPAIGN_TABLE_TYPE);
        })
        .catch((error) => {
          this.showError(error);
        });
    },
    showError(error) {
      this.isLoading = false;
      this.$notify({
        group: "error",
        type: "error",
        duration: -1,
        title: "Error!",
        text: `Please report the query filters: ${error}`,
        width: "75%",
      });
    },
    tableSortStatus(status) {
      this.isLoading = status;
      this.isRendered = !status;
    },
    setTableView(tableType) {
      this.isLoading = false;
      this.isRendered = true;
      this.campaignExists = false;
      this.campaignGiftDataExists = false;
      this.subTotalExist = false;
      this.freshData = true;
      this.progress = 0;

      switch (tableType) {
        case SUBTOTAL_TABLE_TYPE:
          this.subTotalExist = true;
          break;
        case GIFT_TABLE_TYPE:
          this.campaignGiftDataExists = true;
          break;
        case CAMPAIGN_TABLE_TYPE:
          this.campaignExists = true;
          break;
      }
    },
  },
};
</script>

<style scoped>
table {
  counter-reset: rowNumber;
}
table tbody tr {
  counter-increment: rowNumber;
}
table tbody tr td.rowNum:first-child::before {
  content: counter(rowNumber);
  min-width: 1em;
}
table tbody tr:last-child td:first-child::before {
  content: "";
  min-width: 1em;
}
table tbody tr:last-child td,
table tbody tr:last-child th {
  font-weight: 700;
  font-size: 1rem;
  min-width: 1em;
}
thead tr th {
  top: 0;
  border-bottom: 1px solid #dddbda;
  position: -webkit-sticky;
  position: sticky;
  z-index: 3;
  white-space: normal;
}

thead tr:last-child th {
  top: 40px;
  border-bottom: 1px solid #dddbda;
  position: -webkit-sticky;
  position: sticky;
  z-index: 3;
  white-space: normal;
}

tr th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

thead tr:last-child th {
  top: 40px;
  border-bottom: 1px solid #dddbda;
  position: -webkit-sticky;
  position: sticky;
  z-index: 3;
  white-space: normal;
}

td[scope="row"] {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 4;
  background-color: white;
  border-right: 1px solid #dddbda;
}

th:not([scope="row"]):nth-of-type(2) {
  left: 0;
  z-index: 5;
  border-right: 1px solid #dddbda;
}

tbody tr:last-child td {
  bottom: 40px;
  border-top: 1px solid #dddbda;
  position: -webkit-sticky;
  position: sticky;
  z-index: 10;
  white-space: normal;
  background-color: #fff;
}

tfoot th {
  bottom: 0;
  border-top: 1px solid #dddbda;
  position: -webkit-sticky;
  position: sticky;
  z-index: 3;
  background-color: #fafaf9;
  color: #514f4d;
  padding: 0.25rem 0.5rem;
  font-weight: 700;
  line-height: normal;
  white-space: normal;
}

.slds-pill__label {
  color: black;
}

.rowNumCol {
  width: 75px;
  text-align: center;
}
.campaignName {
  width: 175px;
}
.listText {
  width: 65ch;
}
.selectText {
  width: 25ch;
}
.longText {
  width: 200px;
}
.numberCol,
.dateCol {
  width: 125px;
}
.shortNumCol {
  width: 85px;
}
.campaignData {
  width: 150px;
}
.numStyle {
  text-align: right;
  padding: 0 0.3em;
}
.textColumn {
  word-wrap: break-word;
  white-space: -moz-pre-wrap;
  white-space: pre-line;
}
.showHidePosition {
  right: 45px;
}
.table-scroll {
  overflow-x: scroll;
  width: 96.75vw;
}
</style>
